import Strozzi1 from '../Strozzi/Strozzi.webp'
import Strozzi2 from '../Strozzi/Strozzi (2).webp'
import Strozzi3 from '../Strozzi/Strozzi (3).webp'
import Strozzi4 from '../Strozzi/Strozzi (4).webp'
import Strozzi5 from '../Strozzi/Strozzi (5).webp'
import Strozzi6 from '../Strozzi/Strozzi (6).webp'
import Strozzi7 from '../Strozzi/Strozzi (7).webp'
import Strozzi8 from '../Strozzi/Strozzi (8).webp'
import Strozzi9 from '../Strozzi/Strozzi (9).webp'
import Strozzi10 from '../Strozzi/Strozzi (10).webp'
import Strozzi11 from '../Strozzi/Strozzi (11).webp'
import Strozzi12 from '../Strozzi/Strozzi (12).webp'
import Strozzi13 from '../Strozzi/Strozzi (13).webp'



const Strozziimages =[
Strozzi1,Strozzi2,Strozzi3,Strozzi4,Strozzi5,Strozzi6,Strozzi7,Strozzi8,Strozzi9,Strozzi10,Strozzi11,Strozzi12,Strozzi13
]

export default Strozziimages;